import {Component, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ToggleModel } from '../toggle.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';

@Component({
    selector: 'abw-toggle-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToggleFormComponent),
        multi: true
      }
    ],
    templateUrl: './toggle-form.component.html',
    styleUrls: ['./toggle-form.component.scss']
})
export class ToggleFormComponent extends AbstractWorkflowFormComponent<ToggleModel, string> {
  onToggleChanged(_event) {
    this.onValueChanged(_event.detail.checked);
  }
}